import React from "react";

export type TNoDataComponent = {
  message?: string;
  title?: string;
}

const NoDataComponent = ({ message, title }: TNoDataComponent) => {
  return (
    <div className="tw-flex tw-justify-center tw-items-center tw-h-[100%]">
      <figure className="tw-relative tw-text-center">
        <img
          src={process.env.PUBLIC_URL + "/img/place_holder_no_data.svg"}
          alt="logo"
          className="tw-max-w-[210px] tw-max-h-[120px] tw-mt-20"
        />
        <div className="tw-max-w-[210px] tw-max-h-[120px] tw-mt-2">
          <label className={`tw-text-xl tw-text-[#172B4D]`}>
            {title ?? "No Data Found"}
          </label>
          <br />
          {message ? <label className={`tw-text-sm tw-text-[#6D788C] tw-font-semibold tw-mt-2`}>
            {message}
          </label> : null}
        </div>
      </figure>
    </div>
  );
};

export default NoDataComponent;
